import React, { useState } from 'react';
import { useRefreshState } from '../../lib/refreshState';
import { FiMic, FiClock, FiSettings } from 'react-icons/fi';
import { confirmDiscardChanges } from '../../lib/unsavedChanges';
import TranscribeWorkbench from './components/TranscribeWorkbench';
import SavedTranscriptsTab from './components/SavedTranscriptsTab';
import TranscribeSettingsTab from './components/TranscribeSettingsTab';
import './TranscribePage.css';

type TabId = 'transcribe' | 'saved' | 'settings';
const TABS: { id: TabId; label: string; icon: React.ReactNode }[] = [
  { id: 'transcribe', label: 'Transcribe', icon: <FiMic /> },
  { id: 'saved', label: 'Saved (30 days)', icon: <FiClock /> },
  { id: 'settings', label: 'Settings', icon: <FiSettings /> },
];

export default function TranscribePage() {
  const [tab, setTab] = useRefreshState<TabId>('tab', 'transcribe', v => ['transcribe', 'saved', 'settings'].includes(v as string));
  const [resetKey, setResetKey] = useState(0);

  const switchTab = async (id: TabId) => {
    if (!(await confirmDiscardChanges())) return;
    setTab(id);
    setResetKey((k) => k + 1);
  };

  return (
    <div className="trx-page">
      <div className="trx-head">
        <div>
          <h1><FiMic /> Transcribe</h1>
          <p className="trx-sub">
            Audio &amp; video → text, free and private. Everything runs in your browser —
            your media is never uploaded or stored. Handles Hindi, US &amp; India English.
          </p>
        </div>
      </div>

      <div className="trx-tabs" role="tablist" aria-label="Transcribe sections">
        {TABS.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            className={`trx-tab ${tab === t.id ? 'active' : ''}`}
            onClick={() => switchTab(t.id)}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      <React.Fragment key={`${tab}-${resetKey}`}>
        {tab === 'transcribe' && <TranscribeWorkbench />}
        {tab === 'saved' && <SavedTranscriptsTab />}
        {tab === 'settings' && <TranscribeSettingsTab />}
      </React.Fragment>
    </div>
  );
}
